export default {
  header: '',
  link: 'Clear all',
  footer: ''
};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/newton/wp-content/themes/newton/node_modules/instantsearch.js/es/widgets/clear-all/defaultTemplates.js
// module id = 622
// module chunks = 0